(() => {
  const styleId = 'clubhouse-contrast-guard';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = '.clubhouse-article .age-table thead th{background:#062a23!important;color:#fff!important;border-bottom-color:rgba(255,255,255,.18)!important}';
    document.head.appendChild(style);
  }

  const articleColumn = document.querySelector('.clubhouse-article .article-column');
  const tocTargets = document.querySelectorAll('[data-clubhouse-toc]');
  if (articleColumn && tocTargets.length) {
    const headings = Array.from(articleColumn.querySelectorAll('.article-section[id] > h2, section[id] > h2'))
      .filter((heading) => heading.closest('[id]'))
      .slice(0, 14);

    if (headings.length) {
      tocTargets.forEach((target) => {
        const isDesktop = target.getAttribute('data-clubhouse-toc') === 'desktop';
        target.replaceChildren();

        if (isDesktop) {
          const label = document.createElement('strong');
          label.textContent = 'In this guide';
          target.appendChild(label);
        }

        headings.forEach((heading) => {
          const section = heading.closest('[id]');
          const link = document.createElement('a');
          link.href = `#${section.id}`;
          link.textContent = heading.textContent.trim().replace(/\s+/g, ' ');
          target.appendChild(link);
        });
      });
    }
  }

  const navItem = document.querySelector('.clubhouse-template .nav-item, .clubhouse-article .nav-item');
  const trigger = navItem ? navItem.querySelector('.nav-trigger') : null;
  if (!navItem || !trigger) return;

  const closeMenu = () => {
    navItem.classList.remove('open');
    trigger.setAttribute('aria-expanded', 'false');
  };

  trigger.addEventListener('click', (event) => {
    event.stopPropagation();
    const isOpen = navItem.classList.toggle('open');
    trigger.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('click', (event) => {
    if (!navItem.contains(event.target)) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
})();
